/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Box from '@mui/material/Box';
import DataLoadingCard from 'common/DataLoadingCard';
import NoAvailableCard from 'common/NoAvailableCard';
import palette from '../palette';

const MuiDataGrid = {
  defaultProps: {
    getRowClassName: params => {
      return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
    },
    getRowSpacing: () => {
      return {
        bottom: 0,
        top: 0,
      };
    },
    pageSizeOptions: [50, 100, 250, 500],
    slotProps: {
      filterPanel: { sx: { maxWidth: '100vw' } },
    },
    slots: {
      loadingOverlay: () => (
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <DataLoadingCard />
        </Box>
      ),
      noRowsOverlay: () => (
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <NoAvailableCard />
        </Box>
      ),
    },
  },
  styleOverrides: {
    root: {
      '& .MuiButtonBase-root.MuiCheckbox-root': {
        color: palette._next.text.secondary,
      },
      '& .MuiButtonBase-root.MuiCheckbox-root.Mui-checked .MuiSvgIcon-root': {
        color: palette._next.surface.white,
        fill: palette._next.secondary.main,
      },
      '& .MuiDataGrid-aggregationColumnHeaderLabel': {
        bottom: '4px',
        color: palette._next.secondary.main,
        fontWeight: 600,
        letterSpacing: '0.17px',
        lineHeight: '100%',
        position: 'absolute',
        right: '16px',
      },
      '& .MuiDataGrid-cell': {
        border: `1px solid ${palette._next.surface.border}`,
        padding: '8px 16px',
      },
      '& .MuiDataGrid-cell.editable-fields': {
        backgroundColor: palette.secondary.light,
        borderLeftColor: `${palette.surface.white} !important`,
        borderRightColor: `${palette.surface.white} !important`,
        padding: '8px 16px',
      },
      '& .MuiDataGrid-cell.highlighter': {
        backgroundColor: palette.secondary.light,
        borderLeftColor: `${palette.surface.white} !important`,
        borderRightColor: `${palette.surface.white} !important`,
        padding: '8px 16px',
      },
      '& .MuiDataGrid-cell.volume-error': {
        backgroundColor: palette.error.light,
        border: `1px solid ${palette.error.dark} !important`,
      },
      '& .MuiDataGrid-cellContent': {
        fontFamily: 'Overpass',
      },
      '& .MuiDataGrid-columnHeaders': {
        '& .MuiButtonBase-root.MuiCheckbox-root': {
          color: palette._next.surface.white,
        },
        '& .MuiButtonBase-root.MuiCheckbox-root.Mui-checked .MuiSvgIcon-root': {
          color: palette._next.surface.white,
        },
        '& .MuiDataGrid-columnHeader': {
          fontWeight: 600,
          letterSpacing: '0.17px',
          lineHeight: '100%',
          padding: '0px 16px',
        },
        '& .MuiDataGrid-columnHeaderCheckbox': {
          padding: 1,
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          fontFamily: 'Overpass',
          fontWeight: 600,
          lineHeight: '100%',
        },
        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          alignSelf: 'center',
          display: 'flex',
        },
        '& .MuiDataGrid-pinnedColumnHeaders': {
          backgroundColor: palette._next.table.header,
          boxShadow: 'none',
          color: palette._next.surface.white,
          top: 'inherit',
        },
        '& .MuiSvgIcon-root': {
          color: palette._next.surface.white,
          fill: palette._next.secondary.white,
        },
        backgroundColor: palette._next.table.header,
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        color: palette._next.surface.white,
      },
      '& .MuiDataGrid-columnSeparator': {
        marginTop: '-3px',
        top: 'inherit',
      },
      '& .MuiDataGrid-overlayWrapperInner': {
        height: '100%',
      },

      '& .MuiDataGrid-pinnedColumns': {
        overflow: 'hidden',
      },
      '& .MuiDataGrid-pinnedRows': {
        '& .MuiDataGrid-cell': {
          '& .MuiDataGrid-footerCell': {
            border: 0,
            color: palette._next.text.primary,
            fontWeight: 600,
          },
          backgroundColor: palette._next.surface.white,
          border: 0,
          fontWeight: 600,
        },
        border: 0,
        overflow: 'hidden',
      },
      '& .MuiDataGrid-row': {
        '&.even': {
          backgroundColor: palette._next.surface.white,
        },
        '&.odd': {
          backgroundColor: palette._next.surface.alt,
        },
      },
      '& .MuiDataGrid-toolbarContainer': {
        // Override default MUI DataGrid toolbar button styles
        // overrides src\library\theme\components\MuiButtonBase.js
        '& .MuiButtonBase-root': {
          color: palette._next.secondary.main,
        },
        '& .MuiButtonBase-root:hover': {
          backgroundColor: palette._next.secondary.lighter,
        },
        flex: 'none',
        height: '59px',
        marginBottom: 8,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
      },
      '& .MuiDataGrid-virtualScroller': {
        borderBottom: `1px solid ${palette._next.surface.border}`,
      },
      '&.MuiDataGrid-root--densityCompact': {
        '& .MuiDataGrid-aggregationColumnHeaderLabel': {
          bottom: '10px',
          fontSize: '8px',
          right: '16px',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          fontSize: '12px',
        },
      },
      borderBottom: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none',
    },
  },
};

export default MuiDataGrid;
